import { detectOS } from "../../utils";


/**
 * Adjusts the position of an image object to fit within a specified clip path.
 *
 * @param {Object} object - The image object to be adjusted.
 * @param {Object} clipPath - The clip path object that defines the boundaries.
 */
export const replaceImageInContainer = ( object, clipPath ) => {

  const clipPathCenter = clipPath.getCenterPoint();

  const clipPathBorders = {
    left: clipPathCenter.x - clipPath.width / 2,
    right: clipPathCenter.x + clipPath.width / 2,
    top: clipPathCenter.y - clipPath.height / 2,
    bottom: clipPathCenter.y + clipPath.height / 2,
  };

  const radians = (object.angle * Math.PI) / 180;

  const cos = Math.cos(radians);
  const sin = Math.sin(radians);

  // Calculate corners of the object
  const halfWidth = (object.width * object.scaleX) / 2;
  const halfHeight = (object.height * object.scaleY) / 2;

  const corners = [
    { x: -halfWidth, y: -halfHeight }, // Top-left
    { x: halfWidth, y: -halfHeight }, // Top-right
    { x: -halfWidth, y: halfHeight }, // Bottom-left
    { x: halfWidth, y: halfHeight }, // Bottom-right
  ].map((corner) => {
    return {
      x:
        object.left +
        corner.x * cos -
        corner.y * sin,
      y:
        object.top +
        corner.x * sin +
        corner.y * cos,
    };
  });

  // Find the bounding box of the rotated corners
  const imageBorders = {
    left: Math.min(...corners.map((corner) => corner.x)),
    right: Math.max(...corners.map((corner) => corner.x)),
    top: Math.min(...corners.map((corner) => corner.y)),
    bottom: Math.max(...corners.map((corner) => corner.y)),
  };

  // Adjust the position of the object to fit within the clipPath borders
  if (imageBorders.left > clipPathBorders.left) {
    object.set({
      left: object.left - (imageBorders.left - clipPathBorders.left),
    });
  }
  if (imageBorders.right < clipPathBorders.right) {
    object.set({
      left: object.left + (clipPathBorders.right - imageBorders.right),
    });
  }
  if (imageBorders.top > clipPathBorders.top) {
    object.set({
      top: object.top - (imageBorders.top - clipPathBorders.top),
    });
  }
  if (imageBorders.bottom < clipPathBorders.bottom) {
    object.set({
      top: object.top + (clipPathBorders.bottom - imageBorders.bottom),
    });
  }
const os = detectOS()
  if (os === "iOS" || os === "Android" || os === "Linux") {
    const currentWidth = imageBorders.right - imageBorders.left;
    const currentHeight = imageBorders.bottom - imageBorders.top;

    const clipWidth = clipPathBorders.right - clipPathBorders.left;
    const clipHeight = clipPathBorders.bottom - clipPathBorders.top;

    let scaleAdjustment = 1;

    if ( currentWidth < clipWidth || currentHeight < clipHeight ) {
      const widthScale = clipWidth / currentWidth;
      const heightScale = clipHeight / currentHeight;

      scaleAdjustment = Math.max( widthScale, heightScale );

      object.set( {
        scaleX: object.scaleX * scaleAdjustment,
        scaleY: object.scaleY * scaleAdjustment,
      } );
    }
  }
};